"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useDropdownMenu(itemCount) {
    var _a = react_1.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var currentFocusIndex = react_1.useRef(null);
    var firstRun = react_1.useRef(true);
    var clickedOpen = react_1.useRef(false);
    var buttonRef = react_1.useRef(null);
    var itemRefs = react_1.useRef([]);
    react_1.useEffect(function () {
        itemRefs.current = __spreadArrays(Array(itemCount)).map(function () { return react_1.createRef(); });
    }, [itemCount]);
    var isKeyboardEvent = function (e) {
        return e.key !== undefined;
    };
    var moveFocus = function (itemIndex) {
        var _a;
        currentFocusIndex.current = itemIndex;
        (_a = itemRefs.current[itemIndex].current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    react_1.useEffect(function () {
        if (firstRun.current) {
            firstRun.current = false;
            return;
        }
        if (isOpen && !clickedOpen.current) {
            moveFocus(0);
        }
        else if (!isOpen) {
            clickedOpen.current = false;
        }
    }, [isOpen]);
    react_1.useEffect(function () {
        var handleEveryClick = function (event) {
            if (!isOpen) {
                return;
            }
            setTimeout(function () {
                if (!(event.target instanceof Element)) {
                    return;
                }
                if (event.target.closest('[role="menu"]') instanceof Element) {
                    return;
                }
                setIsOpen(false);
            }, 10);
        };
        document.addEventListener('click', handleEveryClick);
        return function () { return document.removeEventListener('click', handleEveryClick); };
    }, [isOpen]);
    var buttonListener = function (e) {
        if (isKeyboardEvent(e)) {
            var key = e.key;
            if (!['Enter', ' ', 'Tab', 'ArrowDown'].includes(key)) {
                return;
            }
            if ((key === 'Tab' || key === 'ArrowDown') && clickedOpen.current && isOpen) {
                e.preventDefault();
                moveFocus(0);
            }
            else if (key !== 'Tab') {
                e.preventDefault();
                setIsOpen(true);
            }
        }
        else {
            clickedOpen.current = !isOpen;
            setIsOpen(!isOpen);
        }
    };
    var itemListener = function (e) {
        var _a;
        var key = e.key;
        if (!['Tab', 'Shift', 'Enter', 'Escape', 'ArrowUp', 'ArrowDown'].includes(key)) {
            return;
        }
        var newFocusIndex = currentFocusIndex.current;
        if (key === 'Escape') {
            setIsOpen(false);
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            return;
        }
        else if (key === 'Tab') {
            setIsOpen(false);
            return;
        }
        else if (key === 'Enter') {
            if (!e.currentTarget.href) {
                e.currentTarget.click();
            }
            setIsOpen(false);
            return;
        }
        if (newFocusIndex !== null) {
            if (key === 'ArrowUp') {
                newFocusIndex -= 1;
            }
            else if (key === 'ArrowDown') {
                newFocusIndex += 1;
            }
            if (newFocusIndex > itemRefs.current.length - 1) {
                newFocusIndex = 0;
            }
            else if (newFocusIndex < 0) {
                newFocusIndex = itemRefs.current.length - 1;
            }
        }
        if (newFocusIndex !== null) {
            moveFocus(newFocusIndex);
        }
    };
    var buttonProps = {
        onKeyDown: buttonListener,
        onClick: buttonListener,
        tabIndex: 0,
        ref: buttonRef,
        role: 'button',
        'aria-haspopup': true,
        'aria-expanded': isOpen,
    };
    var itemProps = __spreadArrays(Array(itemCount)).map(function (ignore, index) { return ({
        onKeyDown: itemListener,
        tabIndex: -1,
        role: 'menuitem',
        ref: itemRefs.current[index],
    }); });
    return { buttonProps: buttonProps, itemProps: itemProps, isOpen: isOpen, setIsOpen: setIsOpen };
}
exports.default = useDropdownMenu;
//# sourceMappingURL=use-dropdown-menu.js.map